import * as angular from 'angular';

import { ComponentDefinition } from '@models/index';
import { IApplicationService } from '@services/data';

class ModelExportPanelController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;

    static $inject = ['applicationService'];

    constructor(private _applicationService: IApplicationService) {
    }

    $onInit() {
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
    }

    downladAsExcelFile() {
        this.isLoading = true;
        this.loadingMessage = 'Generating Excel file';
        this._applicationService.downloadExcel()
            .finally(() => this.isLoading = false);
    }
}

export const wtModelExportPanel: ComponentDefinition = {
    componentId: 'wtModelExportPanel',
    controller: ModelExportPanelController,
    template: require('./modelExportPanel.component.html'),
    controllerAs: 'vm',
    bindings: {
        isLoading: '=?',
        loadingMessage: '=?'
    }
};
